var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{staticClass:"tslc-text-area",attrs:{"rows":_vm.rows || 3,"disabled":_vm.disabled,"color":"#243674","outlined":"","placeholder":_vm.placeholder,"value":_vm.value},on:{"input":e => _vm.$emit('input', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }